import { connect } from 'react-redux';

import UpgradesBubble from './UpgradesBubble';

const Container = (props) => <UpgradesBubble {...props} />;

const mapStateToProps = ({ login }) => ({
  isLoggedIn: login.isLoggedIn,
});

export default connect(mapStateToProps)(Container);
